import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { addJsonLdLocalBusiness } from '@/actions/JsonLdActions';
import { CompanyView } from '@/components/pages/company';
import Layout from '@/container/Layout';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { companyPath, getAbsolutePath } from '@/utils/router/links';
/**
 * 会社概要ページ（認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const CompanyPage = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        // Json-Ld のタグ表示
        dispatch(addJsonLdLocalBusiness());
    }, [dispatch]);
    const title = '会社概要 | PROFFIT';
    const description = META_DESCRIPTION.company();
    return (_jsxs(Layout, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(companyPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(CompanyView, { className: 'mt-60 lg:mt-80' })] }));
};
